define('home/models/FollowRecommendation',[
    'backbone',

    'core/UniqueModel',
], function (
    Backbone,

    UniqueModel
) {
    'use strict';

    var FollowRecommendation = Backbone.Model.extend({
        defaults: {
            reason: '',
        },

        initialize: function () {
            this.object = this.get('object');
            this.unset('object');
        },
    });

    UniqueModel.addType('FollowRecommendation', FollowRecommendation);

    return FollowRecommendation;
});

